import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = ["src"]

import { ref } from 'vue'
import axios from "@/api/files"


export default /*@__PURE__*/_defineComponent({
  __name: 'updateCalendarModal',
  props: {
    months: {}
  },
  emits: ['close', 'updated'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const form = ref({
  id: props.months.id,
  month: props.months.month,
  file: null as File | null,
  filePath: props.months.name
})

const previewUrl = ref<string | null>(props.months.path)

const onImageChange = (e: Event) => {
  const file = (e.target as HTMLInputElement).files?.[0]
  if (file) {
    form.value.file = file
    previewUrl.value = URL.createObjectURL(file)
  }
}


const uploadFile = async (file: File): Promise<string> => {
  const formData = new FormData()
  formData.append('no', props.months.fileNo)
  formData.append('data', file)
  formData.append('oldFilePath', props.months.path)
  console.log([...formData.entries()]); 
  const response = await axios.updateFiles( formData)
  console.log(response.data)


  return response.data.filePath
}



const submit = async  () => {
  try {

let newFilePath = form.value.filePath
    if (form.value.file) {
      newFilePath = await uploadFile(form.value.file)
    }

    console.log("나옴?")

    emit('updated')
    emit('close')
  } catch (err) {
    console.error(err)
  }
}

const close = () => emit('close')


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-overlay",
    onClick: _withModifiers(close, ["self"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "일정 백그라운드", -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("label", null, "이미지", -1)),
        _createElementVNode("input", {
          type: "file",
          onChange: onImageChange
        }, null, 32),
        (previewUrl.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: previewUrl.value,
              class: "preview"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", { class: "actions" }, [
        _createElementVNode("button", { onClick: submit }, " 저장 "),
        _createElementVNode("button", { onClick: close }, " 닫기 ")
      ])
    ])
  ]))
}
}

})